// @flow

export type OrderDetMoboQty = {
  __typename: string,
};

export type OrderDetItem = {
  __typename: string,
  MoboQty: Array<OrderDetMoboQty>,
};

const removeTypenamesFromOrderDet = (
  OrderDet?: Array<OrderDetItem>,
): Array<OrderDetItem> => {
  if (!Array.isArray(OrderDet)) {
    return [];
  }

  return OrderDet.map((i: any) => {
    const { __typename, ...rest } = i;

    if (Array.isArray(rest.MoboQty)) {
      return {
        ...rest,
        MoboQty: rest.MoboQty.map((m: OrderDetMoboQty) => {
          const { __typename: _t, ...p } = m;

          return p;
        }),
      };
    }

    return rest;
  });
};

const removeTypeNamesFromOrderAccount = OrderAccount => {
  if (
    !OrderAccount ||
    !Object.keys(OrderAccount).length ||
    !OrderAccount.AddressOptions
  )
    return OrderAccount;

  const { __typename, ...restAddress } = OrderAccount.AddressOptions;

  return {
    ...OrderAccount,
    AddressOptions: {
      ...restAddress,
      Addr: restAddress.Addr.map(item => {
        const { __typename, ...rest } = item;

        return rest;
      }),
    },
  };
};

export { removeTypenamesFromOrderDet, removeTypeNamesFromOrderAccount };
